/**
 * The request permission vocabulary — `view`, ten granular permissions, and the two legacy launch
 * tiers. The tiers are permanent roll-ups: each granular permission's `granted_*` relation unions
 * the tier that subsumed it in-graph, so a set configured before the granular vocabulary existed
 * confers the equivalent verbs without a tuple backfill.
 */
export const REQUEST_PERMISSIONS = [
  'view',
  'perform_base_tasks',
  'perform_admin_tasks',
  'edit_metadata',
  'manage_participants',
  'pause',
  'reject',
  'delete',
  'edit_submissions',
  'manage_documents',
  'manage_assignees',
  'manage_workflow',
  'administer',
] as const
export type RequestPermission = (typeof REQUEST_PERMISSIONS)[number]

export const requestGrantsRelation = (permission: RequestPermission): `grants_${RequestPermission}` => `grants_${permission}`
export const requestGrantedRelation = (permission: RequestPermission): `granted_${RequestPermission}` => `granted_${permission}`
export const requestCanRelation = (permission: RequestPermission): `can_${RequestPermission}` => `can_${permission}`
